import { EventLog } from "@vp/models";
import { defaultEventLogsFilter, EventLogFilter } from "./event-log-filter";

export type EventLogsStateModel = {
  filter: Partial<EventLogFilter>;
  userEventLogs: EventLog[] | null;
  errors: string[];
  metaData: Record<string, unknown> | null;
};

export const defaultEventLogsState = (): EventLogsStateModel => {
  return {
    filter: defaultEventLogsFilter(),
    userEventLogs: [],
    errors: [],
    metaData: null
  };
};
